import React from 'react';
import { Card, LockedNotice, Pill, SectionHeader } from './ui';
import { PROGRAM_NAMES } from '../../pages/journey/journeyApi';

const Block = ({ title, children, testid }) => (
  <Card data-testid={testid}>
    <p className="text-[11px] uppercase tracking-[0.2em] text-teal-700 font-semibold mb-3">{title}</p>
    <div className="text-slate-700 text-sm sm:text-base leading-relaxed">{children}</div>
  </Card>
);

export const CareerSummary = ({ data: d, go }) => {
  const s = d.summary;
  if (!s) return (<><SectionHeader title="My Career Summary" />
    <LockedNotice testid="summary-locked" title="Available after your consultation" text="Your consultant reviews your registration, readiness results and consultation findings, then approves a personalised summary for you." /></>);
  const e = s.engine;
  return (
    <>
      <SectionHeader eyebrow={`Approved by ${s.approved_by}`} title="My Career Summary">Included with your ₹499 Career Clarity Consultation, yours to keep whether or not you enrol in a program.</SectionHeader>
      <div className="grid lg:grid-cols-2 gap-5">
        <Block title="Current career situation" testid="summary-situation">{s.current_situation}</Block>
        <Block title="Strengths" testid="summary-strengths">{s.strengths_text}</Block>
        <Block title="Development areas" testid="summary-development">
          <p>{s.development_text}</p>
          <ul className="mt-4 space-y-2">{e.gaps.map((g) => (
            <li key={g.area} className="flex items-start gap-2 text-sm"><Pill className={g.severity === 'high' ? 'bg-rose-50 text-rose-700' : 'bg-amber-50 text-amber-700'}>{g.severity}</Pill><span><strong>{g.area}</strong> — {g.reason}</span></li>))}
          </ul>
        </Block>
        <Block title="Target roles & priorities" testid="summary-roles">
          <div className="flex flex-wrap gap-2 mb-4" data-testid="summary-target-roles">{e.target_roles.map((r) => <Pill key={r} className="bg-[#0b1f4d] text-white">{r}</Pill>)}</div>
          <p className="text-xs text-slate-500 mb-1">Provisional learning level</p><p className="font-semibold capitalize mb-3">{e.provisional_level}</p>
          <p className="text-xs text-slate-500 mb-1">Recommended next steps</p>
          <ol className="list-decimal pl-5 space-y-1">{e.next_actions.map((a) => <li key={a}>{a}</li>)}</ol>
        </Block>
        <Block title="Why we recommend this" testid="summary-explanation">
          <p>{s.explanation}</p>
          <p className="mt-4 font-semibold text-[#0b1f4d]" data-testid="summary-recommended-program">{s.primary ? `Recommended: ${PROGRAM_NAMES[s.primary]}` : 'No paid program needed right now'}</p>
          {s.primary && <button onClick={() => go('programs')} className="mt-3 text-sm font-semibold text-teal-700" data-testid="summary-see-programs">See program options & prices →</button>}
        </Block>
        <Block title="Proposed milestones" testid="summary-milestones">
          <ul className="space-y-1">{e.milestones.map((m) => <li key={m}>• {m}</li>)}</ul>
        </Block>
      </div>
    </>
  );
};
